import CryptoJS from "crypto-js";

function createKey(secretKey) {
  return CryptoJS.SHA256(secretKey).toString(CryptoJS.enc.Hex).substring(0, 32);
}

const secretKey1 = process.env.REACT_APP_API_SECRET_KEY;

export function decryptData(encryptedData) {
    if (!secretKey1) {
    throw new Error("API secret key is not configured");
  }
  const key = createKey(secretKey1);

  const parts = encryptedData.split(':');
  if (parts.length !== 2) {
    return;
  }

  const ivBase64 = parts[0];
  const cipherText = parts[1];

  let iv;
  try {
    iv = CryptoJS.enc.Base64.parse(ivBase64);
  } catch (error) {
    return;
  }

  let decryptedData;
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, CryptoJS.enc.Utf8.parse(key), {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedData || decryptedData === "") {
      return bytes.toString(CryptoJS.enc.Base64); 
    }
    const parsedData = JSON.parse(decryptedData);
    return parsedData;
  } catch (error) {
    throw new Error('Decryption failed');
  }
}
